import { useParams } from 'react-router'
import Page from '@/components/common/Page'
import OutreachCampaignsTab from '@/pages/clients/ClientProviders/OutreachCampaignsTab'

export default function OutreachCampaignsPage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Email Campaigns"
      helpContent={{
        header: 'Email Campaigns',
        body: (
          <div>
            <p>Send bulk outreach emails to selected providers and track replies and follow-ups.</p>
            <h4>How it works:</h4>
            <ul style={{ marginLeft: 20 }}>
              <li>Select providers from your pipeline</li>
              <li>Write your email with AI assistance</li>
              <li>Run AI review for legal and marketing compliance</li>
              <li>Send to all selected providers via Gmail</li>
              <li>Track replies and manage follow-ups</li>
            </ul>
          </div>
        ),
      }}
    >
      <OutreachCampaignsTab clientId={clientId} />
    </Page>
  )
}
